import React from "react";
import ReactDOM from "react-dom";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap-css-only/css/bootstrap.min.css";
import "mdbreact/dist/css/mdb.css";
import "./index.css";

//Azure Ready
import App from "./App";

import { BrowserRouter as Router } from "react-router-dom";
import registerServiceWorker from "./registerServiceWorker";
import { GoogleOAuthProvider } from "@react-oauth/google";
// import App from "./App";
import { store } from "./app/store";
import { Provider } from "react-redux";
ReactDOM.render(
  <Provider store={store}>
    <GoogleOAuthProvider clientId="691410375756-qpmjddm2nlegjg3abp2crld3b4rddhjo.apps.googleusercontent.com">
      <Router>
        <App />
      </Router>
    </GoogleOAuthProvider>
  </Provider>,
  document.getElementById("root")
);

// registerServiceWorker();
